<div
  class="destination-settings-form"
  [class.destination-settings-form--readonly]="readonly"
  [class.destination-settings-form--clipping-sidebar]="appearance === 'clipping-sidebar'"
  [ngSwitch]="platformId"
>
  <ng-container *ngSwitchCase="2">
    <div class="destination-settings-form__readonly-row" *ngIf="privacyLevel">
      <span class="label">Privacy level</span>
      <span class="value">{{ privacyLevel }}</span>
    </div>
    <div class="destination-settings-form__readonly-row" *ngIf="publishMode">
      <span class="label">Publish mode</span>
      <span class="value">{{ publishMode }}</span>
    </div>
    <div class="ts-form-group">
      <div class="ts-action">
        <mat-checkbox
          [disabled]="readonly"
          [checked]="disableComment"
          (change)="onTikTokCheckboxChange('disableComment', $event.checked)"
        ></mat-checkbox>
        <span class="label">Disable comments</span>
      </div>
    </div>
    <div class="ts-form-group">
      <div class="ts-action">
        <mat-checkbox
          [disabled]="readonly"
          [checked]="disableDuet"
          (change)="onTikTokCheckboxChange('disableDuet', $event.checked)"
        ></mat-checkbox>
        <span class="label">Disable duet</span>
      </div>
    </div>
    <div class="ts-form-group">
      <div class="ts-action">
        <mat-checkbox
          [disabled]="readonly"
          [checked]="disableStitch"
          (change)="onTikTokCheckboxChange('disableStitch', $event.checked)"
        ></mat-checkbox>
        <span class="label">Disable stitch</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="3">
    <div class="destination-settings-form__instagram">
      <div class="ts-form-group content-control-dropdown destination-settings-form__dropdown-row">
        <div class="ts-action">
          <span class="label">Default post type</span>
          <icn-dropdown
            [large]="true"
            [allowMultiple]="false"
            [listDown]="true"
            [disabled]="readonly"
            [selectedValue]="defaultPostType"
            (selectedValueChange)="onInstagramDefaultPostTypeChange($event)"
          >
            <icn-dropdown-item
              *ngFor="let option of instagramPostTypes"
              [value]="option.value"
              [title]="option.label"
            ></icn-dropdown-item>
          </icn-dropdown>
        </div>
      </div>

      <div class="destination-settings-form__facebook-checkbox">
        <mat-checkbox
          [disabled]="readonly"
          [checked]="shareToFeed"
          (change)="onInstagramShareToFeedChange($event.checked)"
        ></mat-checkbox>
        <span class="label">Share to feed</span>
        <span
          class="destination-settings-form__field-help"
          tabindex="0"
          aria-label="Share to feed setting information"
        >
          ?
          <span class="destination-settings-form__field-tooltip">
            {{ instagramShareToFeedTooltip }}
          </span>
        </span>
      </div>

      <div class="destination-settings-form__facebook-checkbox">
        <mat-checkbox
          [disabled]="readonly"
          [checked]="isAiGenerated"
          (change)="onInstagramIsAiGeneratedChange($event.checked)"
        ></mat-checkbox>
        <span class="label">AI-generated content</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="4">
    <div class="destination-settings-form__facebook">
      <div class="ts-form-group content-control-dropdown destination-settings-form__dropdown-row">
        <div class="ts-action">
          <span class="label">Default upload type</span>
          <icn-dropdown
            [large]="true"
            [allowMultiple]="false"
            [listDown]="true"
            [disabled]="readonly"
            [selectedValue]="defaultPublishTarget"
            (selectedValueChange)="onFacebookPublishTargetChange($event)"
          >
            <icn-dropdown-item
              *ngFor="let option of facebookPublishTargets"
              [value]="option.value"
              [title]="option.label"
              [selectable]="isFacebookPublishTargetSelectable(option.value)"
            ></icn-dropdown-item>
          </icn-dropdown>
        </div>

        <div class="ts-action destination-settings-form__facebook-dropdown-field--category">
          <div class="destination-settings-form__facebook-dropdown-label">
            <span class="label">Content category</span>
            <span
              class="destination-settings-form__field-help"
              tabindex="0"
              aria-label="Content category setting information"
            >
              ?
              <span class="destination-settings-form__field-tooltip">
                {{ facebookPageVideoOnlyTooltip }}
              </span>
            </span>
          </div>
          <icn-dropdown
            [large]="true"
            [allowMultiple]="false"
            [listDown]="true"
            [disabled]="readonly"
            [selectedValue]="facebookContentCategorySelection"
            (selectedValueChange)="onFacebookContentCategoryChange($event)"
          >
            <icn-dropdown-item
              [value]="facebookContentCategoryNone"
              title="None"
            ></icn-dropdown-item>
            <icn-dropdown-item
              *ngFor="let option of facebookContentCategories"
              [value]="option.value"
              [title]="option.label"
            ></icn-dropdown-item>
          </icn-dropdown>
        </div>
      </div>

      <div class="destination-settings-form__facebook-checkbox">
        <mat-checkbox
          [disabled]="readonly"
          [checked]="reelsEligible"
          (change)="onFacebookReelsEligibleChange($event.checked)"
        ></mat-checkbox>
        <span class="label">Allow Reels on this Page</span>
      </div>

      <div class="destination-settings-form__facebook-checkbox">
        <mat-checkbox
          [disabled]="readonly"
          [checked]="embeddable"
          (change)="onFacebookEmbeddableChange($event.checked)"
        ></mat-checkbox>
        <span class="label">Embeddable</span>
        <span
          class="destination-settings-form__field-help"
          tabindex="0"
          aria-label="Embeddable setting information"
        >
          ?
          <span class="destination-settings-form__field-tooltip">
            {{ facebookPageVideoOnlyTooltip }}
          </span>
        </span>
      </div>

      <div class="destination-settings-form__facebook-checkbox">
        <mat-checkbox
          [disabled]="readonly"
          [checked]="noStory"
          (change)="onFacebookNoStoryChange($event.checked)"
        ></mat-checkbox>
        <span class="label">No story</span>
        <span
          class="destination-settings-form__field-help"
          tabindex="0"
          aria-label="No story setting information"
        >
          ?
          <span class="destination-settings-form__field-tooltip">
            {{ facebookPageVideoOnlyTooltip }}
          </span>
        </span>
      </div>
    </div>
  </ng-container>

  <p *ngSwitchDefault class="destination-settings-form__empty">
    No platform-specific settings to display.
  </p>
</div>
